import * as actions from '../actions';

import { deprecated } from '../../../constants/texts';

class Router extends React.PureComponent {
  constructor(props) {
    super(props);

    window.addEventListener('hashchange', event => {
      const hash = event.newURL.split('#')[1];
      props.actions.changeRoute(hash);
    });
  }

  componentDidMount() {
    console.warn('eDoCat Router -- ', deprecated);
    const { hash, home, path } = this.props;

    const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
    const routes = children.map(item => item.props.path);

    if (routes.length === 0) {
      console.warn('Router must have at least one Route');
    }

    if (
      // in production mode always start from home
      process.env.NODE_ENV !== 'production' &&
      (!hash || !routes.includes(path))
    ) {
      window.location.hash = home;
    }

    if (process.env.NODE_ENV === 'production') {
      window.location.hash = home;
    }
  }

  componentWillUnmount() {
    window.onhashchange = null;
  }

  render() {
    const { path } = this.props;

    const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
    const component = children.filter(item => item.props.path === path)[0];

    if (!component) {
      console.warn(`No such path ${path} was found in routes definition`);
      return null;
    }

    return <div className="Edocat-Router">{component}</div>;
  }
}

export const mapStateToProps = state => state.navigation;

export const mapDispatchToProps = dispatch => ({
  actions: redux.bindActionCreators(actions, dispatch),
});

export default reactRedux.connect(mapStateToProps, mapDispatchToProps)(Router);
